import React, { useEffect, useRef } from 'react';

const ConfirmationDialog = ({ isOpen, onClose, onConfirm, title, message }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      dialogRef.current?.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className='fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50'
      onClick={onClose}
    >
      <div
        className='relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='mt-3 text-center'>
          <h3
            className='text-lg leading-6 font-medium text-gray-900'
            ref={dialogRef}
            tabIndex={-1}
          >
            {title}
          </h3>
          <div className='mt-2 px-7 py-3'>
            <p className='text-sm text-gray-500'>{message}</p>
          </div>
          <div className='items-center px-4 py-3'>
            <button
              className='px-4 py-2 bg-red-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-300 mb-3'
              onClick={onConfirm}
            >
              Confirm
            </button>
            <button
              className='px-4 py-2 bg-gray-300 text-black text-base font-medium rounded-md w-full shadow-sm hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300'
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
